import { create } from "zustand";
import { devtools } from "zustand/middleware";

const initialState = {
  selectedShipping: null,
  searchQuery: "",
  shippingFilterSearchQuery: {
    page: 1,
    office: "",
    type: "All",
    courier: "All",
    orderDate: {
      from: "",
      to: "",
    },
    shipDate: {
      from: "",
      to: "",
    },
    sortBy: "ship_date",
    sortValue: "DESC",
  },
  officeOptions: [],
  officeOptionsLoaded: false,
  pageCount: 0,
  currentPage: 1,
  totalItems: 0,
  itemsPerPage: 20,
  shippingList: [],
  shippingListLoading: false,
};

const useShippingStore = create(
  devtools((set) => ({
    ...initialState,
    setSelectedShipping: (shipping) => set({ selectedShipping: shipping }),
    setSearchQuery: (query) => set({ searchQuery: query }),
    setShippingFilterSearchQuery: (query) =>
      set((state) => {
        const { dba: _removed, ...patch } = query;
        const shippingFilterSearchQuery = {
          ...state.shippingFilterSearchQuery,
          ...patch,
        };
        delete shippingFilterSearchQuery.dba;

        return { shippingFilterSearchQuery };
      }),
    setOfficeOptions: (options) =>
      set({ officeOptions: options, officeOptionsLoaded: true }),
    setPageCount: (count) => set({ pageCount: count }),
    setCurrentPage: (page) => set({ currentPage: page }),
    setTotalItems: (total) => set({ totalItems: total }),
    setItemsPerPage: (items) => set({ itemsPerPage: items }),
    setShippingList: (list) => set({ shippingList: list }),
    setShippingListLoading: (loading) => set({ shippingListLoading: loading }),
    reset: () => set(initialState),
  })),
);

export default useShippingStore;
